"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryAction = exports.ButtonWrapper = exports.Caption = exports.Header = exports.ContentWrapper = exports.EmptyStateWrapper = void 0;
var styles_1 = require("@mui/material/styles");
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
exports.EmptyStateWrapper = (0, styles_1.styled)(material_1.Grid)(function () { return ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors_1.tannerGray[50],
}); });
exports.ContentWrapper = (0, styles_1.styled)(material_1.Grid)(function () { return ({
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    maxWidth: 500,
}); });
exports.Header = (0, styles_1.styled)(material_1.Typography)(function () { return ({
    textAlign: 'center',
    marginBottom: 4,
}); });
exports.Caption = (0, styles_1.styled)(material_1.Typography)(function () { return ({
    textAlign: 'center',
    color: colors_1.tannerGray[700],
}); });
exports.ButtonWrapper = (0, styles_1.styled)(material_1.Grid)(function () { return ({
    marginTop: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}); });
exports.SecondaryAction = (0, styles_1.styled)(material_1.Grid)(function (_a) {
    var hasSubmitAction = _a.hasSubmitAction;
    return ({
        marginTop: hasSubmitAction ? 16 : 0,
    });
});
//# sourceMappingURL=styles.js.map